<div class="content">
  <div class="body">
    <div class="slide">
      <div class="image-box single">
        <on-ui-cover [cover]="{img: course.cover?.md?.url, form:'base', type:'cover'}"></on-ui-cover>
      </div>
      <div class="subject">
        <div class="subject-item">{{course.subject.title}}</div>
        <div class="subject-title">{{course.title}}</div>
        <div class="subject-subtitle">Материалов: 0</div>
      </div>
      <div class="actions">
        <on-ui-button label="Unpublish"
                      class="transparent"
                      (onclick)="clicked.emit({type:'Unpublish', course:course})">
        </on-ui-button>
        <on-ui-button label="Edit"
                      class="transparent"
                      (onclick)="clicked.emit({type:'Edit', course:course})">
        </on-ui-button>
        <on-ui-button label="Archive"
                      class="transparent"
                      (onclick)="clicked.emit({type:'Archive', course:course})">
        </on-ui-button>
      </div>
    </div>
  </div>
</div>
